import { Theme } from "@mui/material";

export const getFooterLinkStyles = (theme: Theme) => ({
  display: 'block',
  width: '100%',
  textDecoration: "none",
  color: "white",
  opacity: 0.7,
  py: 1,
  "&:hover": {
    color: theme.palette.primary.main,
  },
  "&:focus": {
    color: theme.palette.primary.main,
  },
})

export const getLegalLinkStyles = (theme: Theme, isDesktop: boolean) => ({
  width: "100%",
  display: { xs: 'inline', md: "block" },
  textAlign: isDesktop ? 'end' : "start",
  textDecoration: "underline",
  color: "white",
  opacity: 0.7,
  "&:hover": {
    color: theme.palette.primary.main,
  },
  "&:focus": {
    color: theme.palette.primary.main,
  },
})